module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_footer_image_04-8489d633641fe89f74dc0a18570d5d10.jpg";